/* Marvreco Navy theme: small, dependency free */
(function () {
  // Mobile menu
  var btn = document.querySelector('[data-menu-toggle]'), menu = document.getElementById('MobileNav');
  if (btn && menu) btn.addEventListener('click', function () {
    var open = menu.hidden; menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Product gallery
  var stage = document.getElementById('Stage'), badges = document.querySelectorAll('.stage-badge');
  document.querySelectorAll('.thumbs button').forEach(function (b, i) {
    b.addEventListener('click', function () {
      if (!stage) return;
      stage.removeAttribute('srcset'); stage.src = b.dataset.src; stage.alt = b.getAttribute('aria-label') || '';
      // The photo badge belongs to the first photo only; the others carry their own text
      badges.forEach(function (x) { x.hidden = i > 0; });
      document.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  });

  // Swipe the main photo to step through the thumbnails (bunion only until the knee test ends, 24 Oct)
  var stageBox = stage && stage.closest('.stage');
  if (stageBox && document.body.classList.contains('template-product-bunion')) {
    var sx = 0, sy = 0;
    stageBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stageBox.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var list = Array.prototype.slice.call(document.querySelectorAll('.thumbs button')); if (list.length < 2) return;
      var cur = list.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; }); if (cur < 0) cur = 0;
      var next = (cur + (dx < 0 ? 1 : -1) + list.length) % list.length;
      list[next].click();
      list[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }, { passive: true });
  }

  // A link to one FAQ question opens that answer
  document.querySelectorAll('a[href^="#q-"]').forEach(function (a) {
    a.addEventListener('click', function () { var d = document.getElementById(a.getAttribute('href').slice(1)); if (d) d.open = true; });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input'); if (!input) return;
      var min = parseInt(input.min || '0', 10), v = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10);
      input.value = Math.max(min, v);
    });
  });

  // Variant price
  var sel = document.querySelector('select[data-variant]'), price = document.querySelector('[data-price]');
  if (sel && price) sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; if (o && o.dataset.price) price.textContent = o.dataset.price; });

  // Collection: filter by area (product tags area-*) and sort
  var grid = document.querySelector('[data-grid]');
  if (grid) {
    var cards = Array.prototype.slice.call(grid.children), chips = document.querySelectorAll('.chip');
    var apply = function (f) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.f === f ? 'true' : 'false'); });
      cards.forEach(function (c) { c.hidden = f !== 'all' && (c.dataset.areas || '').split(' ').indexOf(f) === -1; });
    };
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.dataset.f); history.replaceState(null, '', c.dataset.f === 'all' ? location.pathname + location.search : '#' + c.dataset.f); }); });
    if (location.hash) apply(location.hash.slice(1));
    var sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.hash = ''; location.href = u.toString(); });
  }
})();

/* Scroll tracking, carried over from the old theme (2026-10-12):
   scroll_25/50/75/100 on every page, and seen_<heading> the first time each section heading comes into view. */
(function () {
  var sent = {};
  function send(name) { if (sent[name] || typeof window.gtag !== 'function') return; sent[name] = true; window.gtag('event', name, { page_path: location.pathname }); }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var d = document.documentElement, max = d.scrollHeight - window.innerHeight;
      if (max > 0) { var pct = window.scrollY / max * 100; [25, 50, 75, 100].forEach(function (m) { if (pct >= m - 0.5) send('scroll_' + m); }); }
      ticking = false;
    });
  }, { passive: true });
  function slug(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').split('_').slice(0, 4).join('_').slice(0, 34); }
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var h = e.target.querySelector('h2') || e.target.querySelector('.label'); if (h && h.textContent.trim()) send('seen_' + slug(h.textContent)); io.unobserve(e.target); }); }, { threshold: 0.35 });
  document.querySelectorAll('main .sec, main .closing').forEach(function (s) { io.observe(s); });
})();

/* Product page scroll moments: red lights switch on, the 15 minute line, the heat dial.
   With reduced motion the CSS shows the finished state and none of this runs. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var lights = document.querySelectorAll('[data-lights]');
  if (lights.length && 'IntersectionObserver' in window) {
    var lo = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-on'); lo.unobserve(e.target); } }); }, { threshold: 0.55 });
    lights.forEach(function (el) { lo.observe(el); });
  }
  var lines = [], dials = [];
  document.querySelectorAll('[data-timeline-bar]').forEach(function (bar) {
    var sec = bar.closest('.sec'); lines.push({ sec: sec, bar: bar, steps: sec ? sec.querySelectorAll('.steps[data-timeline] > div') : [] });
  });
  document.querySelectorAll('[data-heat]').forEach(function (h) {
    dials.push({ sec: h.closest('.sec'), bars: h.querySelectorAll('.heat-bars i'), read: h.querySelector('[data-heat-read]') });
  });
  if (!lines.length && !dials.length) return;
  function progress(el, start, span) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight;
    return Math.max(0, Math.min(1, (vh * start - r.top) / (r.height * span)));
  }
  function update() {
    lines.forEach(function (l) {
      if (!l.sec) return; var p = progress(l.sec, 0.8, 0.7);
      l.bar.style.setProperty('--p', p.toFixed(3));
      for (var i = 0; i < l.steps.length; i++) l.steps[i].classList.toggle('is-done', p >= i / l.steps.length + 0.02);
    });
    dials.forEach(function (d) {
      if (!d.sec) return; var p = progress(d.sec, 0.8, 0.6), n = d.bars.length;
      var lit = Math.max(1, Math.min(n, Math.ceil(p * n)));
      for (var i = 0; i < n; i++) d.bars[i].classList.toggle('is-lit', i < lit);
      if (d.read && d.bars[lit - 1]) d.read.textContent = d.bars[lit - 1].getAttribute('data-level');
      d.sec.style.setProperty('--heat', (p * 1).toFixed(3));
    });
  }
  var queued = false;
  window.addEventListener('scroll', function () { if (queued) return; queued = true; requestAnimationFrame(function () { update(); queued = false; }); }, { passive: true });
  window.addEventListener('resize', update); update();
})();

/* One or two picker: picks the two pack bundle variant, or falls back to quantity 2 with the automatic discount */
(function () {
  document.querySelectorAll('[data-pack]').forEach(function (pack) {
    var form = pack.closest('form'), qty = form && form.querySelector('input[name="quantity"]');
    if (!qty) return;
    pack.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var id = form.querySelector('input[name="id"]');
        // With a bundle product, "Two" swaps the variant (one bundle = 2 units); otherwise it sets quantity 2
        if (r.dataset.variant && id) { id.value = r.dataset.variant; qty.value = 1; } else { qty.value = r.value; }
      });
    });
  });
})();

/* Desktop thumbnail column: drop the bottom fade once scrolled to the end; keep the chosen photo's thumbnail in view */
(function () {
  var t = document.querySelector('.thumbs'); if (!t) return;
  var check = function () { t.classList.toggle('at-end', t.scrollTop + t.clientHeight >= t.scrollHeight - 4); };
  t.addEventListener('scroll', check, { passive: true }); window.addEventListener('resize', check); check();
  t.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); });
})();

/* Umami funnel events: add_to_cart on every product form, checkout_start on the cart, each tagged with the ad (utm_content) that brought the visitor in this session */
(function () {
  var ad = 'none';
  try { var u = new URLSearchParams(location.search).get('utm_content'); if (u) sessionStorage.setItem('marv_ad', u); ad = sessionStorage.getItem('marv_ad') || 'none'; } catch (e) {}
  // Umami sends with keepalive, so the event survives the page change after submit
  var track = function (name, data) { try { if (window.umami) window.umami.track(name, Object.assign({ ad: ad }, data)); } catch (e) {} };
  var V = window.marvVariants || {};
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var id = (form.querySelector('[name="id"]') || {}).value, q = +((form.querySelector('[name="quantity"]') || {}).value || 1), v = V[id] || [];
      track('add_to_cart', { product: location.pathname.split('/').pop(), option: v[0] || String(id), qty: q, value: v[1] ? +(v[1] * q).toFixed(2) : 0, button: form.classList.contains('offer-form') ? 'bottom' : 'top' });
    });
  });
  var co = document.querySelector('button[name="checkout"]');
  if (co && co.form) co.form.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.name !== 'checkout') return;
    var c = window.marvCart || {}; track('checkout_start', { value: c.total || 0, items: c.items || 0 });
  });
})();

/* Discount code line: visitors from an ad get the code applied quietly (a background request, no redirect, so the referrer stays Facebook) */
(function () {
  var el = document.querySelector('[data-code-line]'); if (!el) return;
  var fromAd = /utm_source=facebook/.test(location.search);
  try { fromAd = fromAd || !!sessionStorage.getItem('marv_ad'); } catch (e) {}
  if (!fromAd) return;
  fetch('/discount/' + encodeURIComponent(el.getAttribute('data-code-line')) + '?redirect=/cart.js', { credentials: 'same-origin' }).then(function (r) {
    if (!r.ok) return; var t = el.querySelector('[data-code-text]');
    if (t) t.textContent = 'applied: ' + t.textContent.replace('takes ', '');
    el.classList.add('is-applied');
  }).catch(function () {});
})();
